import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconErrorSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M0 2C0 1 1 0 2 0H14C15 0 16 1 16 2V14C16 15 15 16 14 16H2C1 16 0 15 0 14V2ZM8 3C8.55228 3 9 3.44772 9 4V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V4C7 3.44772 7.44772 3 8 3ZM8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
